/*
 * Sticky Add to cart bar
 * Shows once the product form's Add to cart button scrolls above the viewport.
 * Clicking it clicks the real button so the normal product form (and any app
 * option fields inside it) handles the add.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', class StickyAtc extends HTMLElement {
    connectedCallback() {
      // Fixed positioning breaks inside the transformed sticky header, so live on <body>.
      if (this.parentElement !== document.body) {
        document.querySelectorAll('body > sticky-atc').forEach((bar) => bar !== this && bar.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;

      this.mainButton = document.querySelector('product-form [name="add"]');
      if (!this.mainButton) return;
      this.initialized = true;

      this.button = this.querySelector('[data-sticky-atc-button]');
      this.label = this.querySelector('[data-sticky-atc-label]');
      this.price = this.querySelector('[data-sticky-atc-price]');
      this.mainPrice = document.querySelector('[id^="price-"][id$="__main"]') || document.querySelector('[id^="price-"]');

      this.button.addEventListener('click', this.onClick.bind(this));

      new IntersectionObserver(([entry]) => {
        this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(this.mainButton);

      const sync = this.sync.bind(this);
      const options = { attributes: true, childList: true, subtree: true, characterData: true };
      new MutationObserver(sync).observe(this.mainButton, options);
      if (this.mainPrice) new MutationObserver(sync).observe(this.mainPrice, options);
      this.sync();
    }

    toggle(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', !visible);
      this.button.tabIndex = visible ? 0 : -1;
    }

    sync() {
      this.button.disabled = this.mainButton.disabled;
      this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));

      const mainLabel = this.mainButton.querySelector('span');
      if (mainLabel && mainLabel.textContent.trim()) this.label.textContent = mainLabel.textContent.trim();

      const price = this.currentPrice();
      if (price) this.price.textContent = price;
    }

    currentPrice() {
      if (!this.mainPrice || this.mainPrice.classList.contains('visibility-hidden')) return '';
      const visible = (el) => el.getClientRects().length > 0;
      const item = Array.from(this.mainPrice.querySelectorAll('.price__sale .price-item--sale, .price__regular .price-item--regular'))
        .find(visible);
      return item ? item.textContent.trim() : '';
    }

    onClick() {
      if (this.mainButton.disabled) return;
      this.mainButton.click();

      // If the add did not go through (e.g. required options), bring the form into view.
      setTimeout(() => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) return;
        if (this.mainButton.classList.contains('loading')) return;
        this.mainButton.closest('product-form').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 1500);
    }
  });
}
